export const historyData = [
    {
        year: 2024,
        items: [
            {
                month: 'Декабрь',
                events: [
                    {
                        title: 'Эффективное образование 2024',
                        content: '<p>Программа управленческого обучения &laquo;Школа лидерства&raquo; стала лауреатом в&nbsp;номинации &laquo;Цифровой прорыв года&raquo; в&nbsp;категории &laquo;Инновации и&nbsp;технологии в&nbsp;образовании&raquo; премии &laquo;Эффективное образование 2024&raquo;.</p><p>Обучение направлено на&nbsp;развитие в&nbsp;роли и&nbsp;совершенствование управленческих навыков линейных руководителей &laquo;Норникеля&raquo;. Для обучения сотрудников используется чат-бот с&nbsp;искусственным интеллектом.</p>'
                    },
                    {
                        title: 'Шахта &laquo;Ангидрит&raquo;&nbsp;&mdash; одна из&nbsp;лучших площадок &laquo;Географического диктанта&raquo;',
                        content: '<p>Оргкомитет международной просветительской акции &laquo;Географический диктант&nbsp;&mdash; 2024&raquo; поблагодарил компанию &laquo;Норникель&raquo; и&nbsp;руководство шахты за&nbsp;участие, добавив, что памятные призы от&nbsp;Русского географического общества будут отправлены в&nbsp;начале следующего года.</p><p>Организаторами &laquo;Географического диктанта&raquo; на&nbsp;шахте &laquo;Ангидрит&raquo; рудника &laquo;Кайерканский&raquo; Норильского обеспечивающего комплекса выступили департамент общественных связей ЗФ&nbsp;&laquo;Норникеля&raquo;, местное отделение Русского географического общества, корпоративный университет &laquo;Норильский никель&raquo;, где и&nbsp;расположен учебный подземный полигон, а&nbsp;также Норильский обеспечивающий комплекс.</p><img src="/images/history/news_dec_16_24.webp" alt="Участники «Географического диктанта» на шахте «Ангидрит»" />'
                    }
                ]
            },
            {
                month: 'Сентябрь',
                events: [
                    {
                        title: 'Эффективность. Технологии. Инновации',
                        content: '<p>&laquo;Город профессий&raquo; занял&nbsp;I место в&nbsp;номинации &laquo;Эффективность. Технологии. Инновации&raquo; конкурса корпоративных проектов улучшений &laquo;Трансформация&raquo; IN&rsquo;HUB.</p>'
                    }
                ]
            },
            {
                month: 'Март',
                events: [
                    {
                        title: 'Жители Норильска, Талнаха и Мончегорска получили <a href="https://university.nornik.ru/press-center/events/vitaminKU2024">#витаминКУ</a>',
                        content: '<p>Около 300 человек пришли 30 марта, в субботу, на день открытых дверей Корпоративного университета «Норильский никель», чтобы получить пользу на мастер-классах, лекциях и карьерных консультациях.</p><img src="/images/history/news_march_24.jpg" alt="" />'
                    }
                ]
            },
            {
                month: 'Февраль',
                events: [
                    {
                        title: 'Корпоративный пилот',
                        content: '<p>Интерактивный портал для профориентации школьников город профессий &laquo;Норникеля&raquo; занял&nbsp;I место в&nbsp;номинации &laquo;Корпоративный пилот&raquo; премии RB&nbsp;Digital Awards.</p><p>Интерактивный портал в&nbsp;виде трехмерной карты 10&nbsp;районов стал уникальным инструментом для профориентации школьников. Разработка полностью кастомная: от&nbsp;идеи до&nbsp;элементов на&nbsp;карте.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2023,
        items: [
            {
                month: 'Декабрь',
                events: [
                    {
                        title: '«Учись учиться» продолжает собирать награды',
                        content: '<p>В&nbsp;этот раз&nbsp;II место в&nbsp;номинации «Лучший внутрикорпоративный спецпроект (издательский, в&nbsp;Интернете)» всероссийского конкурса корпоративных СМИ «Медиалидер-2023»</p><img src="/images/history/news_dec_23.jpg" alt="" />'
                    }
                ]
            },
            {
                month: 'Ноябрь',
                events: [
                    {
                        title: 'Корпоративный университет отметил 85-летие',
                        content: '<p>За&nbsp;годы работы #универНорникель стал символом надежности в&nbsp;сфере обучения и&nbsp;развития персонала в&nbsp;«Норникеле». Наши успехи и&nbsp;достижения говорят сами за&nbsp;себя, и&nbsp;мы&nbsp;уверены, что впереди нас вместе с&nbsp;вами ждут новые высоты и&nbsp;горизонты.</p><img src="/images/history/news_nov_23.jpg" alt="" />',
                        anchorLink: '2023-85-years'
                    }
                ]
            },
            {
                month: 'Октябрь',
                events: [
                    {
                        title: 'Проект «Учись учиться» — «HR-проект года»',
                        content: '<p>Проект «Учись учиться» взял гран-при в&nbsp;номинации «HR-проект года, большие организации (5000&nbsp;чел.&nbsp;и&nbsp;больше)» премии за&nbsp;достижения в&nbsp;области обучения и&nbsp;развития человеческого капитала&nbsp;— «Хрустальная пирамида 2023».</p><p>На&nbsp;фото (слева направо): Дарья Крячкова, вице-президент по&nbsp;кадровой политике «Норникеля» и&nbsp;Анна Рыкова, проректор по&nbsp;цифровому обучению #универНорникель.</p><img src="/images/history/pyramid_news231012.jpeg" alt="Награждение победителей конкурса" />'
                    },
                    {
                        title: 'Bravo, Корпоративный университет!',
                        content: '<p>Корпоративный университета взял&nbsp;I место в&nbsp;номинации «Импульс знания» на&nbsp;премии Bravo для работодателей, создающих воодушевляющий контент.</p><p>Награда была вручена Ирине Сорокиной из&nbsp;управления обучения персонала «Норникеля» (на&nbsp;фото в&nbsp;центре).</p><img src="/images/history/bravo_news23107.jpg" alt="Награждение победителей конкурса" />'
                    }
                ]
            },
            {
                month: 'Июль',
                events: [
                    {
                        title: 'Корпоративный университет вошёл в топ лучших предприятий России',
                        content: '<p>В&nbsp;национальном рейтинге «Лиги Лучших предприятий России» среди предприятий, занимающихся подготовкой кадров высшей квалификации, КУ&nbsp;стал «Предприятием года 2022» и&nbsp;занял лидирующие места: </p><z-list tag="ul"><z-list-item>I место среди предприятий Сибирского федерального округа;</z-list-item><z-list-item>I место среди предприятий Красноярского края;</z-list-item><z-list-item>VIII место в&nbsp;общенациональном рейтинге среди предприятий России.</z-list-item></z-list><img src="/images/history/dipl_july_event.jpg" alt="Корпоративный университет вошёл в топ лучших предприятий России" />'
                    }
                ]
            },
            {
                month: 'Май',
                events: [
                    {
                        title: 'Подземный полигон&nbsp;КУ вошел в&nbsp;топ-15 предприятий промышленного туризма',
                        content: '<p>Подборка лучших опубликована в&nbsp;мартовском выпуске журнала &laquo;Турбизнес&raquo;. Учебный полигон Корпоративного университета на&nbsp;базе шахты &laquo;Ангидрит&raquo; рудника &laquo;Кайерканский&raquo; готовит профессиональные кадры для сложных горных работ на&nbsp;объектах горно-металлургического комбината &laquo;Норильский никель&raquo;. Экскурсия &laquo;Забойная смена&raquo; позволит посетить единственный в&nbsp;России подземный учебный полигон, погрузиться в&nbsp;подземный мир суровых условий, скрытых от&nbsp;человеческих глаз, окунуться в&nbsp;атмосферу сложной и&nbsp;опасной профессии горняка.</p> <img src="/images/history/underground-landfill.jpg" alt="Подземный полигон" />'
                    }
                ]
            }
        ]
    },
    {
        year: 2022,
        items: [
            {
                month: 'Август',
                events: [
                    {
                        title: 'Корпоративный университет вошёл в&nbsp;рабочую группу по&nbsp;развитию концепции промышленного туризма на&nbsp;территории НПР',
                        content: '<p>Среди участников&nbsp;&mdash; предприятия горнодобывающей, металлургической отрасли, пищевой промышленности и&nbsp;другие, а&nbsp;также наш учебный подземный полигон на&nbsp;базе шахты &laquo;Ангидрит&raquo;.</p> <img src="/images/history/tourism.jpg" alt="Промышленный туризм" />'
                    }
                ]
            }
        ]
    },
    {
        year: 2021,
        items: [
            {
                month: 'Декабрь',
                events: [
                    {
                        title: '&laquo;Преподаватель года-2021&raquo;',
                        content: '<p>10&nbsp;декабря в&nbsp;спорт-холле &laquo;Айка&raquo; состоялась торжественная церемония подведения итогов конкурса профессионального мастерства на&nbsp;звание &laquo;Преподаватель года-2021&raquo;. По&nbsp;результатам всех конкурсных испытаний были названы лучшие из&nbsp;34&nbsp;участников.</p><p>В&nbsp;номинации &laquo;Преподаватели-профессионалы&raquo; (штатные сотрудники&nbsp;КУ) победили Самсонова Лариса Юрьевна, Журавская Ирина Владимировна, Скучеляс Николай Анатольевич (I, II&nbsp;и&nbsp;III места соответственно).</p><p>Победители в&nbsp;номинации &laquo;Преподаватели&nbsp;&mdash; предметные эксперты&raquo; (специалисты других предприятий и&nbsp;организаций, осуществляющих групповое обучение персонала &laquo;Норникеля&raquo;): Самсонов Сергей Сергеевич, Кудрань Юрий Анатольевич, Новожилова Елена Адольфовна (I, II&nbsp;и&nbsp;III места соответственно).</p> <img src="/images/history/contest-results.jpg" alt="Награждение победителей конкурса" />'
                    }
                ]
            },
            {
                month: 'Июнь',
                events: [
                    {
                        title: 'Корпоративный университет в&nbsp;Мончегорске',
                        content: '<p>18&nbsp;июня 2021 года&nbsp;&mdash; важный день для Корпоративного университета. Мы&nbsp;получили лицензию на&nbsp;осуществление образовательной деятельности в&nbsp;филиале ЧОУ ДПО &laquo;Корпоративный университет &laquo;Норильский никель&raquo; в&nbsp;г. Мончегорск.</p>',
                        anchorLink: '2021-monchegorsk'
                    }
                ]
            },
            {
                month: 'Январь',
                events: [
                    {
                        title: 'Стратегия развития 2022-2025',
                        content: '<p>31&nbsp;января на&nbsp;общем собрании Корпоративного университета ректор Роман Чураевский, представил стратегию развития и&nbsp;приоритеты на&nbsp;ближайшие 3&nbsp;года.</p><p>Одни из&nbsp;главных векторов&nbsp;&mdash; опережающее обучение, внедрение архитектуры обучения компании, а&nbsp;также ESG-повестка. Наиважнейший приоритет, был и&nbsp;остаётся&nbsp;&mdash; развитие собственной команды и&nbsp;культуры непрерывного обучения.</p> <img src="/images/history/strategy.jpg" alt="Люди на собрании в зале" />'
                    }
                ]
            }
        ]
    },
    {
        year: 2020,
        items: [
            {
                month: 'Декабрь',
                events: [
                    {
                        title: 'В&nbsp;Корпоративном университете выбрали преподавателей года&nbsp;&mdash; 2020',
                        content: '<p>Лучших определяли среди штатных преподавателей Корпоративного университета, работников &laquo;Норникеля&raquo;, которые проводят групповое обучение персонала компании, и&nbsp;преподавателей политехнического колледжа НГИИ. Кроме этого, свои навыки продемонстрировал и&nbsp;преподаватель Кольского центра развития персонала. В&nbsp;общей сложности в&nbsp;состязаниях принимали участие 28&nbsp;человек.</p> <img src="/images/history/nnuniver-2020.jpg" alt="Награждение преподавателей года" />'
                    }
                ]
            },
            {
                month: 'Октябрь',
                events: [
                    {
                        title: 'Филиалу&nbsp;&mdash; быть!',
                        content: '<p>20&nbsp;октября 2020 года на&nbsp;заседании совета&nbsp;КУ принято решение о&nbsp;создании филиала в&nbsp;Мончегорске на&nbsp;базе Кольского центра развития персонала.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2019,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Введен в&nbsp;эксплуатацию тренажерный комплекс IM&nbsp;360',
                        content: '<p>В&nbsp;этом году список инновационных технологий, внедряемых в&nbsp;корпоративном университете, пополнили VR-очки и&nbsp;введен в&nbsp;эксплуатацию тренажерный комплекс IM&nbsp;360.</p>'
                    },
                    {
                        title: 'Международный семинар по&nbsp;вопросам госрегулирования в&nbsp;сфере охраны труда',
                        content: '<p>В&nbsp;Корпоративном Университете провели Международный семинар по&nbsp;вопросам госрегулирования в&nbsp;сфере охраны труда и&nbsp;познакомились с&nbsp;практиками, применяемыми на&nbsp;предприятиях большого Норильска. Инициаторами трехдневного семинара выступили Ростехнадзор и&nbsp;компания &laquo;Норникель&raquo;. Вопросы организации охраны труда на&nbsp;опасных производственных объектах горно-металлургического комплекса обсудили руководители и&nbsp;представители нескольких российских и&nbsp;зарубежных предприятий, надзорных структур.</p>'
                    }
                ]
            },
            {
                month: 'Октябрь',
                events: [
                    {
                        title: 'Открыт цикл очного обучения сотрудников минерально-сырьевого комплекса',
                        content: '<p>В&nbsp;октябре 2019 года открыт цикл очного обучения сотрудников минерально-сырьевого комплекса Компании &laquo;Норникель&raquo; по&nbsp;программе &laquo;Корпоративная Культура и&nbsp;ценности Норникеля&raquo;.</p>'
                    }
                ]
            },
            {
                month: 'Ноябрь',
                events: [
                    {
                        title: 'Мероприятие «Трансформация системы управления минерально-сырьевым комплексом ЗФ»',
                        content: '<p>В&nbsp;ноябре в&nbsp;Корпоративном Университете для руководителей и&nbsp;специалистов рудников и&nbsp;функциональных подразделений минерально-сырьевого комплекса ЗФ&nbsp;ПАО ГМК &laquo;Норильский никель&raquo; было проведено мероприятие по&nbsp;вовлеченности работников в&nbsp;проект Заполярного филиала &laquo;Трансформация системы управления минерально-сырьевым комплексом&nbsp;ЗФ&raquo;.</p>'
                    }
                ]
            },
            {
                month: '',
                events: [
                    {
                        title: 'Проведен Конкурс профессионального мастерства «Лучший преподаватель года»',
                        content: ''
                    }
                ]
            }
        ]
    },
    {
        year: 2018,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Завершена реконструкция Учебного подземного полигона',
                        content: '',
                        anchorLink: '2018-reconstruction'
                    },
                    {
                        title: 'Университет стал победителем регионального этапа конкурса лучших практик подготовки рабочих кадров (Красноярский край)',
                        content: ''
                    }
                ]
            },
            {
                month: 'Апрель',
                events: [
                    {
                        title: 'Открытие проекта «Специальные агенты безопасности»',
                        content: '<p>7&nbsp;апреля 2018 года в&nbsp;конференцзале ЧОУ ДПО &laquo;Корпоративный университет &laquo;Норильский никель&raquo; состоялась церемония открытия проекта &laquo;Специальные агенты безопасности&raquo;. Для повышения уровня подготовки квалифицированных кадров для предприятий &laquo;Норникеля&raquo; и&nbsp;эффективности управления образовательным процессом между Корпоративным университетом &laquo;Норильский никель&raquo; и&nbsp;учреждениями профессионального образования заключены соглашения о&nbsp;сотрудничестве в&nbsp;области образовательной и&nbsp;научно-технической деятельности. Партнерами университета выступают Норильский государственный индустриальный институт и&nbsp;Таймырский колледж.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2017,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Университет стал призером IV&nbsp;Всероссийского конкурса «Создавая будущее»',
                        content: '<p>Университет стал призером IV&nbsp;Всероссийского конкурса лучших практик работодателей по&nbsp;развитию человеческого капитала &laquo;Создавая будущее&raquo;.</p>',
                        anchorLink: '2017-award'
                    }
                ]
            }
        ]
    },
    {
        year: 2016,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Открытие Молодежной бизнес-школы «Life навигатор»',
                        content: '<p>В&nbsp;рамках реализации социального проекта &laquo;Мир новых возможностей&raquo; в&nbsp;Университете состоялось торжественное открытие Молодежной бизнес-школы &laquo;Life навигатор&raquo;. Цель&nbsp;&mdash; личностное развитие и&nbsp;профессиональная ориентация учащихся 8-10 классов общеобразовательных школ города Норильска, формирование и&nbsp;развитие у&nbsp;них актуальных компетенций (личностных, профессиональных, творческих, предпринимательских) для успешной социализации и&nbsp;эффективной профессиональной самореализации на&nbsp;территории&nbsp;МО город Норильск.</p>'
                    }
                ]
            },
            {
                month: 'Ноябрь',
                events: [
                    {
                        title: 'Мобильное приложение',
                        content: '<p>В&nbsp;целях обеспечения непрерывного развития ключевых компетенций персонала, позволяющих эффективно и&nbsp;безопасно решать производственные задачи, специалистами Корпоративного университета разработан новый продукт&nbsp;&mdash; специальное мобильное приложение для прохождения тестирования по&nbsp;различным направлениям подготовки. Презентация нового программного обеспечения состоялась 14&nbsp;ноября 2016&nbsp;года.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2015,
        items: [
            {
                month: 'Март',
                events: [
                    {
                        title: 'Переименование в&nbsp;Частное образовательное учреждение дополнительного профессионального образования «Корпоративный университет «Норильский никель»',
                        content: '<p>Решением №1 единственного учредителя (ОАО «Горно-металлургическая компания «Норильский никель»)  Корпоративный университет переименован в Частное образовательное учреждение дополнительного профессионального образования «Корпоративный университет «Норильский никель».</p> <img src="/images/history/nnuniver-1.jpg" alt="Корпоративный университет «Норильский никель»" />',
                        anchorLink: '2015-name-change'
                    }
                ]
            },
            {
                month: '',
                events: [
                    {
                        title: 'Победа в&nbsp;Конкурсе социальных проектов программы «Мир новых возможностей»',
                        content: '<p>Корпоративный университет стал победителем в&nbsp;Конкурсе социальных проектов благотворительной программы &laquo;Мир новых возможностей&raquo; в&nbsp;номинации &laquo;Полюс будущего&raquo;.</p>',
                        anchorLink: '2015-winner'
                    }
                ]
            }
        ]
    },
    {
        year: 2014,
        items: [
            {
                month: 'Февраль',
                events: [
                    {
                        title: 'Запущен в&nbsp;работу тренажерный комплекс UG-360',
                        content: '<p>В корпусе производственного обучения НОУ «Корпоративный университет «Норильский никель» запущен в работу тренажерный комплекс UG-360 для обучения машинистов ПДМ, позволяющий имитировать управление подземными погрузочно-доставочными машинами Caterpillar R1700G и R2900G, разработанный Австралийской фирмой Immersive Technologies Pty Ltd – крупнейшим мировым поставщиком имитаторов наземного и подземного горного оборудования. Восемь преподавателей и инструкторов, которые будут проводить обучение, работать над определением сценариев или настроек на тренажере UG360, а также технических специалистов Университета прошли курс обучения по программе Trainer Advantage и получили специальные сертификаты инструкторов Immersive Technologies, которые принимаются разными организациями всего мира, где используют симуляторы серии Immersive Technologies Advanced Equipment Simulators.</p> <img src="/images/history/ug-360.jpg" alt="Комната комплекса UG-360" />'
                    }
                ]
            }
        ]
    },
    {
        year: 2013,
        items: [
            {
                month: 'Август',
                events: [
                    {
                        title: 'Запуск в&nbsp;эксплуатацию тренажерного комплекса ST-14',
                        content: '<p>В корпусе производственного обучения НОУ «Корпоративный университет «Норильский никель» состоялся запуск в эксплуатацию тренажерного комплекса ST-14 производства компании «Атлас Копко» для обучения машинистов ПДМ.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2012,
        items: [
            {
                month: 'Март',
                events: [
                    {
                        title: 'Самоходная буровая установка Boomer&nbsp;S',
                        content: '<p>На учебно-производственную базу Корпоративного университета поступила самоходная буровая установка Boomer S 1D шведской компании «Атлас Копко». Получение новой техники стало возможным благодаря поддержке проекта руководством ЗФ ОАО «ГМК «Норильский никель».</p> <img src="/images/history/boomer-s.jpg" alt="Работники управляют Boomer S." />'
                    },
                    {
                        title: 'Сотрудничество с&nbsp;ЗАО «Атлас Копко»',
                        content: '<p>Подписано соглашение о взаимовыгодном сотрудничестве в области образовательной, инновационной и производственной деятельности между НОУ «Корпоративный университет «Норильский никель» и ЗАО «Атлас Копко» — ведущим глобальным поставщиком решений для высокопроизводительной индустрии.</p>'
                    },
                    {
                        title: 'Междугородняя конференция «Современные подходы к&nbsp;профессиональному обучению»',
                        content: '<p>В НОУ «Корпоративный университет «Норильский никель» состоялась междугородняя конференция «Современные подходы к профессиональному обучению».</p>'
                    }
                ]
            },
            {
                month: 'Май',
                events: [
                    {
                        title: 'Погрузочно-доставочная машина Caterpillar R1600',
                        content: '<p>В рамках реализации целевого проекта «Внедрение современных технологий подготовки рабочих горных профессий для предприятий минерально-сырьевого комплекса Компании» на учебно-производственную базу НОУ «Корпоративный университет «Норильский никель» поступила погрузочно-доставочная машина Caterpillar R1600.</p> <img src="/images/history/caterpillar.jpg" alt="Класс обучения Caterpillar R1600." />'
                    }
                ]
            },
            {
                month: 'Сентябрь',
                events: [
                    {
                        title: 'Тренажерный учебный комплекс Boomer E2С',
                        content: '<p>Запущен в эксплуатацию тренажерный учебный комплекс Boomer E2С производства компании «Атлас Копко», позволяющий с помощью виртуальных технологий освоить приемы работы на самоходной буровой установке.</p>'
                    }
                ]
            },
            {
                month: 'Декабрь',
                events: [
                    {
                        title: 'Открытие Учебного подземного полигона НОУ «Корпоративный университет «Норильский никель»',
                        content: '<p>Открытие Учебного подземного полигона НОУ «Корпоративный университет «Норильский никель», оборудованного на базе технологических выработок шахты «Ангидрит» рудника «Кайерканский», в рамках реализации целевого проекта «Внедрение современных технологий подготовки рабочих горных профессий для подразделений минерально-сырьевого комплекса Компании». Создание современной учебной площадки, не имеющей аналогов в мире, позволило вывести на новый уровень систему подготовки машинистов погрузочно-доставочных машин и бурильщиков шпуров для горнодобывающих предприятий. Теперь горняки имеют возможность проходить обучение вне действующего производства, но в условиях, максимально приближенных к реальным.</p> <img src="/images/history/university-polygon.jpg" alt="Церемония открытия учебного полигона." />'
                    }
                ]
            },
            {
                month: '',
                events: [
                    {
                        title: 'Программе развития профессиональной ориентации учащихся',
                        content: '<p>С&nbsp;2012 года совместно с&nbsp;ЗФ&nbsp;ПАО &laquo;ГМК &laquo;Норильский никель&raquo; реализуется проект по&nbsp;обучению учащихся 10-11 классов общеобразовательных школ города по&nbsp;специально разработанной &laquo;Программе развития профессиональной ориентации учащихся, мотивированных на&nbsp;приобретение инженерных специальностей&raquo;, которое прошли порядка 780&nbsp;старшеклассников.</p><p>Проводятся семинары-тренинги для представителей Движения молодых специалистов &laquo;Лидер&raquo; и&nbsp;развивающие мероприятия по&nbsp;программе управленческой подготовки &laquo;Школа молодого менеджера&raquo;, в&nbsp;которых принимают участие студенты 3-4 курсов ФГБОУ ВПО &laquo;Норильский индустриальный институт&raquo;, обучение студентов рабочим профессиям.</p>'
                    },
                    {
                        title: 'Корпоративный университет лауреат Главной Всероссийской Премии «Лидеры экономики России»',
                        content: '<p>Корпоративный университет награжден Почетным дипломом Лауреата Главной Всероссийской Премии &laquo;Лидеры экономики России&raquo; в&nbsp;номинации &laquo;Лидер качества&raquo;.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2011,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Благодарность КГКУ «ЦЗН г.&nbsp;Норильска»',
                        content: '<p>Корпоративному университету вручена Благодарность КГКУ &laquo;ЦЗН г. Норильска&raquo; за&nbsp;активное участие в&nbsp;реализации мероприятий по&nbsp;содействию занятости населения&nbsp;МО город Норильск.</p>'
                    },
                    {
                        title: '2-ое место среди 650&nbsp;000 предприятий РФ за&nbsp;превосходство в&nbsp;отрасли и&nbsp;развитие экономики России',
                        content: '<p>Корпоративный университет удостоен 2-го места среди 650&nbsp;000 предприятий Российской Федерации за&nbsp;превосходство в&nbsp;отрасли и&nbsp;развитие экономики России. Сертификат подтвержден цифрами Росстата и&nbsp;аудитом рейтинга &laquo;Обучение в&nbsp;образовательных учреждениях дополнительного профессионального образования&raquo;.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2010,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Работа проекта «Клуб «Профнавигатор»',
                        content: '<p>С&nbsp;2010 года в&nbsp;рамках проекта &laquo;Клуб &laquo;Профнавигатор&raquo; проводятся профориентационные экскурсии для старшеклассников городских школ на&nbsp;предприятия Компании, в&nbsp;процессе которых школьники знакомятся с&nbsp;историей предприятия, его производством, технологией процесса выпуска продукции, делятся впечатлениями и&nbsp;задают вопросы работникам. За&nbsp;это время организовано более 380&nbsp;экскурсий, в&nbsp;которых участвовали более 6700&nbsp;школьников.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2009,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Программа «Профессиональный старт»',
                        content: '<p>С&nbsp;2009 года в&nbsp;рамках программы &laquo;Профессиональный старт&raquo; с&nbsp;целью стимулирования стремления студентов к&nbsp;собственному самообразованию и&nbsp;профессиональному росту на&nbsp;предприятиях города Норильска реализуется комплекс адаптационных мероприятий, в&nbsp;которых приняли участие в&nbsp;период прохождения практики уже более 2000 студентов ВУЗов&nbsp;РФ.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2006,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Задача своевременного пополнения коллектива предприятий города и&nbsp;Компании квалифицированными специалистами была решена',
                        content: '<p>В&nbsp;2004-2006 гг. задача своевременного пополнения коллектива предприятий города и&nbsp;Компании квалифицированными специалистами была решена. Созданная система оперативно готовила и&nbsp;перераспределяла работников комбината, благодаря чему потребности основного производства были обеспечены. Система культивировала профессионализм специалистов, способность действовать в&nbsp;экстремальных ситуациях, рационально использовать человеческий капитал.</p>'
                    }
                ]
            },
            {
                month: 'Октябрь',
                events: [
                    {
                        title: 'Корпоративный университет «Норильский никель»',
                        content: '<p>Решением &#8470;&nbsp;1&nbsp;единственного учредителя (ОАО &laquo;Горно-металлургическая компания &laquo;Норильский никель&raquo;) создано Негосударственное образовательное учреждение дополнительного профессионального образования (повышения квалификации) &laquo;Корпоративный университет &laquo;Норильский никель&raquo;. При этом Центр подготовки персонала реорганизован в&nbsp;Заполярный филиал НОУ &laquo;Корпоративный университет &laquo;Норильский никель&raquo;.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2003,
        items: [
            {
                month: 'Ноябрь',
                events: [
                    {
                        title: 'Центр подготовки персонала',
                        content: '<p>Приказом&nbsp;и.&nbsp;о. Директора ЗФ&nbsp;ОАО &laquo;ГМК &laquo;Норильский никель&raquo;&nbsp;&mdash; Председателя Правления от&nbsp;04.11.2003&nbsp;г. &#8470;ЗФ/383-р Учебно-курсовой комбинат переименован в&nbsp;Центр подготовки персонала.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 2000,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Российская организация высокой социальной эффективности',
                        content: '<p>В&nbsp;Доме правительства в&nbsp;Москве по&nbsp;итогам конкурса &laquo;Российская организация высокой социальной эффективности&raquo; в&nbsp;трех номинациях из&nbsp;четырех первые места присуждены РАО &laquo;Норильский никель&raquo;&nbsp;&mdash; &laquo;Оплата труда и&nbsp;социальные выплаты&raquo;, &laquo;Квалификация кадров, система их&nbsp;подготовки&raquo;, &laquo;Содержание и&nbsp;развитие социальной инфраструктуры и&nbsp;реализация социальных программ&raquo;.</p><p>В&nbsp;2000-2004 гг. РАО &laquo;Норильский никель&raquo; трижды присуждено 1&nbsp;место по&nbsp;итогам конкурса &laquo;Российская организация высокой социальной эффективности&raquo; в&nbsp;номинации &laquo;Квалификация кадров, система их&nbsp;подготовки&raquo;.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1986,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Дипломированные специалисты среди ИТР составляют 98,1%',
                        content: '<p>Ведена обязательная периодическая аттестация инженерно-технических работников и&nbsp;руководящих кадров. Создан резерв специалистов, который более чем вдвое превышает число должностей. Дипломированные специалисты среди ИТР составляют 98,1%.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1985,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Учебно-курсовой комбинат в&nbsp;г.&nbsp;Дудинка',
                        content: '<p>Построено здание учебно-курсового комбината в&nbsp;г.&nbsp;Дудинка.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1983,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Почетная грамота ВДНХ',
                        content: '<p>Класс &laquo;Правила дорожного движения&raquo; награжден Почетной грамотой ВДНХ за&nbsp;3-е место по&nbsp;итогам Всероссийского смотра-конкурса по&nbsp;профессиональному обучению.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1982,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Неделя молодого рабочего и&nbsp;наставника',
                        content: '<p>Принято совместное постановление руководства комбината, президиума Таймырского окружкома профсоюза и&nbsp;бюро ГК&nbsp;ВЛКСМ о&nbsp;проведении &laquo;Недели молодого рабочего и&nbsp;наставника&raquo;.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1981,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Всесоюзный смотр профессионального обучения рабочих',
                        content: '<p>С&nbsp;1981 по&nbsp;1985 год ежегодно проводится Всесоюзный смотр профессионального обучения рабочих.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1976,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'В ЦУКК прошли обучение около 270 тысяч рабочих',
                        content: '<p>За&nbsp;1976-1985 гг. в&nbsp;ЦУКК прошли обучение около 270 тысяч рабочих. В&nbsp;перечне основных рабочих профессий&nbsp;&mdash; 56&nbsp;наименований. Среди новых форм подготовки&nbsp;&mdash; школы передовых методов труда, курсы целевого назначения, экономическая подготовка, учеба молодежи и&nbsp;подростков.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1975,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Здание ЦУКК',
                        content: '<p>Начал работу Центральный учебно-курсовой комбинат в&nbsp;новом учебном здании на&nbsp;Талнахской,&nbsp;31.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1974,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Введен в&nbsp;действие учебный корпус Учебно-курсового комбината',
                        content: '<p>Приказом директора комбината Б.И. Колесникова введен в&nbsp;действие учебный корпус Учебно-курсового комбината, обновлена материально-техническая база его филиалов, увеличилось число оборудованных классов, созданы учебные пункты в&nbsp;ГРУ, шахтопроходческом тресте, для работников Дудинского порта. Создан единый учебно-методический совет комбината, разработано положение о&nbsp;профессиональной подготовке, переподготовке и&nbsp;повышении квалификации рабочих кадров, об&nbsp;Учебно-курсовом комбинате и&nbsp;его педагогическом совете.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1961,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Учебно-курсовой комбинат в&nbsp;районе «Нулевого пикета»',
                        content: '<p>Открыт учебно-курсовой комбинат в&nbsp;районе &laquo;Нулевого пикета&raquo;.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1960,
        items: [
            {
                month: 'Сентябрь',
                events: [
                    {
                        title: 'Учебно-курсовой комбинат',
                        content: '<p>С&nbsp;целью улучшить организационное и&nbsp;методическое руководство техническим обучением приказом В.И. Долгих от&nbsp;10&nbsp;сентября &#8470;&nbsp;378 отделение подготовки кадров преобразовано в&nbsp;Учебно-курсовой комбинат, который к&nbsp;концу 60-х ежегодно выпускал более 10000 обученных специалистов, необходимых городу и&nbsp;комбинату.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1955,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Школы технической учебы',
                        content: 'В&nbsp;1955-1959 гг. комбинат, а&nbsp;вместе с&nbsp;ним и&nbsp;город Норильск вступают в&nbsp;новый этап развития. Формирование норильского промышленного района и&nbsp;становление города Норильска проходило параллельно освоению Талнаха и&nbsp;строительству &laquo;Надежды&raquo;. Открытие Талнахского месторождения коренным образом меняет экономическую перспективу и&nbsp;требует ускоренного развития социального комплекса всего города, а&nbsp;переоснащение комбината и&nbsp;расширение города&nbsp;&mdash; хорошо подготовленных специалистов. После слома лагерной системы, кадровые службы комбината столкнулись с&nbsp;очень серьезными трудностями, шла массовая смена кадров, причем самой высокой квалификации на&nbsp;решающих участках. Требовалось принятие решительных мер для быстрой и&nbsp;массовой подготовки новых кадров, приезжающих с&nbsp;&laquo;материка&raquo; на&nbsp;строительство города и&nbsp;комбината. С&nbsp;целью систематического обучения молодежи непосредственно на&nbsp;производстве на&nbsp;базе отделения по&nbsp;подготовке кадров НГМК открыты школы технической учебы, где кроме общих дисциплин, изучались и&nbsp;специальные&nbsp;&mdash; буровзрывные работы, крепление, транспорт, техника безопасности. За&nbsp;эти годы рабочие, обученные профессии и&nbsp;повысившие квалификацию, составили 52&nbsp;% от&nbsp;общей их&nbsp;численности на&nbsp;предприятии.'
                    }
                ]
            }
        ]
    },
    {
        year: 1949,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Работа с&nbsp;кадрами стала включать результаты научных и&nbsp;социологических исследований',
                        content: 'В&nbsp;1949-1954 гг. по&nbsp;мере того, как объемы производства комбината росли, принципиально менялась техническая оснащенность производства и&nbsp;качество труда, возрастала необходимость в&nbsp;новой системе подготовки кадров, соответствующей изменившимся постлагерным условиям. Постепенно работа с&nbsp;кадрами стала включать результаты научных и&nbsp;социологических исследований, а&nbsp;планы приобретать комплексный, системный характер.'
                    }
                ]
            }
        ]
    },
    {
        year: 1948,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Обучено 15876 человек',
                        content: 'С&nbsp;начала деятельности обучено 15876 человек.'
                    }
                ]
            }
        ]
    },
    {
        year: 1947,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Курсы бригадиров и&nbsp;мастеров-металлургов',
                        content: '<p>Организована сеть технического обучения рабочих на&nbsp;курсах повышения квалификации и&nbsp;в&nbsp;стахановских школах, курсах бригадиров по&nbsp;лагерным подразделениям, начали работу долгосрочные курсы подготовки мастеров-металлургов.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1944,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Ставки для преподавателей',
                        content: '<p>Постановлением СНК СССР и&nbsp;указанием ЦФО НКВД установлены часовые ставки оплаты труда преподавателей.</p>'
                    },
                    {
                        title: 'Курсы повышения квалификации',
                        content: '<p>Организована сеть технического обучения рабочих на&nbsp;курсах повышения квалификации и&nbsp;в&nbsp;стахановских школах.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1943,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'В 1943-1946 гг. обучено более 3 тысяч человек, 10 тысяч работников повысили квалификацию',
                        content: '<p>В&nbsp;годы ВОВ производственные мощности комбината резко возрастают. Он&nbsp;становится одним из&nbsp;основных поставщиков никеля, меди, кобальта для оборонной промышленности страны. В&nbsp;условиях военного времени начальник комбината А.А. Панюков определил начальникам цехов персональную ответственность за&nbsp;качество работы групп технического обучения рабочих, уравняв ее&nbsp;с&nbsp;выполнением плановых показателей. В&nbsp;годы войны обучено более 3&nbsp;тысяч человек и&nbsp;10&nbsp;тысяч работников повысили свою квалификацию. Успехи военного времени, правительственные награды, которые получили комбинат и&nbsp;его работники в&nbsp;1943, 1945, 1946&nbsp;гг., в&nbsp;значительной степени зависели и&nbsp;от&nbsp;службы подготовки кадров.</p>',
                        anchorLink: '1943-education'
                    },
                    {
                        title: 'Школы фабрично-заводского обучения',
                        content: '<p>Организованы школы фабрично-заводского обучения (ФЗО). Произведен набор в&nbsp;количестве 100&nbsp;человек.</p>',
                        anchorLink: '1943-education-enrollment'
                    }
                ]
            }
        ]
    },
    {
        year: 1942,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Учебный комбинат',
                        content: '<p>Отделение подготовки кадров реорганизовано в&nbsp;Учебный комбинат, с&nbsp;введением первых штатных преподавателей. Вопросы расстановки, учебы, воспитания кадров отражены в&nbsp;приказах, планах и&nbsp;первоочередных мероприятиях того времени, а&nbsp;задача подготовки кадров определена руководством комбината и&nbsp;города как самая важная и&nbsp;ответственная.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1940,
        items: [
            {
                month: '',
                events: [
                    {
                        title: 'Методсовет',
                        content: '<p>Отделение подготовки кадров подчинено заместителю директора комбината-главному инженеру Звереву В.С. Организован методсовет для руководства вопросами подготовки кадров и введена должность зав. учебной частью.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1939,
        items: [
            {
                month: 'Январь',
                events: [
                    {
                        title: 'Квалификационные комиссии',
                        content: '<p>При управлении лагеря создаются четыре постоянно действующие квалификационные комиссии.</p>'
                    }
                ]
            },
            {
                month: '',
                events: [
                    {
                        title: 'Курсы обучения рабочих',
                        content: '<p>Организованы первые курсы обучения рабочих обслуживанию паровых котлов, для работы в&nbsp;угольных и&nbsp;рудных штольнях, в&nbsp;строительных организациях. Обучено первые 100&nbsp;чел.</p>'
                    }
                ]
            }
        ]
    },
    {
        year: 1938,
        items: [
            {
                month: 'Ноябрь',
                events: [
                    {
                        title: 'Отделение подготовки кадров',
                        content: '<p>Приказом А.П. Завенягина от&nbsp;12&nbsp;ноября &#8470;&nbsp;442 было создано отделение подготовки кадров для обеспечения квалифицированными рабочими цехов и&nbsp;площадок строящегося Норильского комбината (далее&nbsp;&mdash; комбинат).</p> <img src="/images/history/prikaz.png" alt="Приказ по Норильскому комбинату." />',
                        anchorLink: '1938-education'
                    }
                ]
            }
        ]
    }
]
